import type { MailAccountSummary } from "@/lib/types/mail";

const STORAGE_KEY = "mail_accounts_v1";

type AccountsCacheEntry = {
  accounts: MailAccountSummary[];
  savedAt: number;
};

export function readAccountsSessionCache(): MailAccountSummary[] | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as AccountsCacheEntry;
    if (!parsed?.accounts?.length) return null;
    return parsed.accounts;
  } catch {
    return null;
  }
}

export function writeAccountsSessionCache(accounts: MailAccountSummary[]): void {
  try {
    const entry: AccountsCacheEntry = { accounts, savedAt: Date.now() };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entry));
  } catch {
    /* quota */
  }
}

export function clearAccountsSessionCache(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
